import React from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import Tooltip from 'components/Tooltip';

const ProgressStep = ({ step, isDisabled, isCurrent, isFulfilled, level }) => {
  const stepContent = isDisabled ? step?.disabledContent : step?.fulfilledContent;
  const stepClickable = step.onClick && isFulfilled;
  const stepClassNames = cc([
    'progressStep',
    {
      'progressStep--current': isCurrent,
      'progressStep--fulfilled': isFulfilled || isCurrent,
      [`progressStep--${level}`]: isCurrent && level
    }
  ]);
  const stepContentClassNames = cc([
    'progressStep__content',
    {
      'progressStep__content--noStyle': step?.replaceBG,
      'progressStep__content--clickable': stepClickable
    }
  ]);
  return (
    <div className={stepClassNames}>
      {step?.label && <span className="progressStep__label">{step.label}</span>}
      <Tooltip
        label={step.tooltipText}
        className={stepContentClassNames}
        level={level}
        position="above"
      >
        <div className="progressStep__clickWrapper" onClick={stepClickable ? step.onClick : null}>
          {stepContent}
        </div>
      </Tooltip>
      {step?.extra && <span className="progressStep__extra">{step.extra}</span>}
    </div>
  );
};

ProgressStep.defaultProps = {
  isDisabled: false
};

ProgressStep.propTypes = {
  step: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool,
  isCurrent: PropTypes.bool.isRequired,
  isFulfilled: PropTypes.bool.isRequired,
  level: PropTypes.string.isRequired
};

export default ProgressStep;
